var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarehouseStock = function SvgWarehouseStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.719 9.737h-8.78c-.95-.193-1.588-.531-1.915-1.014-.49-.724-.504-1.596 0-2.223.838-1.044 1.966-1.291 3.383-.744C5.983 3.7 7.11 2.67 8.787 2.67c1.679 0 2.862.657 3.55 1.972 1.13-.3 2.09-.115 2.877.557 1.18 1.008 1.19 3.16 0 3.983-.44.304-.91.403-1.374.484-.249.043-.622.067-1.121.071z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.788 0c1.64 0 2.912.576 3.748 1.706l.126.182.239-.032c.956-.102 1.82.126 2.559.683l.182.147c1.49 1.271 1.494 3.915-.052 4.986-.47.325-.91.464-1.636.59-.292.051-.697.077-1.23.082l-6.31-.001A2.668 2.668 0 0 0 4.96 7.24l-.059-.174 6.81.001a8.2 8.2 0 0 0 .918-.047l.096-.015c.553-.096.836-.185 1.112-.376.828-.573.825-2.232-.052-2.98-.617-.527-1.35-.67-2.278-.423L11 3.36l-.24-.46c-.574-1.093-1.53-1.624-2.971-1.624-1.355 0-2.249.815-2.753 2.616l-.192.686-.675-.26c-1.16-.449-1.98-.269-2.632.543-.31.387-.315.94.008 1.44a2.779 2.779 0 0 0-.923.662l-.134.088c-.651-.96-.656-2.131.025-2.979.884-1.1 2.075-1.486 3.463-1.154l.01.003.036-.098C4.707 1.058 5.904.084 7.568.005L7.788 0z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    cx: 2.626,
    cy: 9.044,
    rx: 1.672,
    ry: 1.628
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.684 11.836)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.2,
    x: 0.6,
    y: 0.6,
    width: 9.116,
    height: 7.464,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.192.943v2.224l-3.568.5-.5-2.724h4.068z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.227 16.548H3.909a.5.5 0 0 1-.5-.5v-3.82",
    stroke: "#000",
    strokeWidth: 1.2
  }))));
};

export default SvgWarehouseStock;